import $ from "jquery";
import Swiper from "swiper";
import { A11y, Autoplay, Navigation, Pagination } from "swiper/modules";

const SWITCHCASES = {
    INIT: "init",
    TRANSITIONEND: "transitionend",
    TRANSITIONSTART: "transitionstart",
};

const heroAnimations = (el) => {
    let $el = $(el);

    if ($el.length === 0) {
        console.warn("Element not found for Swiper initialization");
        return;
    }

    const handlePagination = (swiper) => {
        const $activeElement = $el
            .find(".hero__element--active")
            .attr("tag-line-data");
    };
    const handleDirection = () =>
        $(window).width() < 1024 ? "vertical" : "vertical";

    const handleClasses = (type, swiper) => {
        const $activeElement = $el
            .find(".hero__element--active")
            .attr("tag-line-data");

        $(".hero__animationTagline__element").text($activeElement);
        switch (type) {
            case SWITCHCASES.INIT:
                $(".hero__element--next")
                    .next()
                    .addClass("hero__element--extra");
                break;
            case SWITCHCASES.TRANSITIONEND:
                $(".hero__element--next").removeClass("hero__element--extra");
                $(".hero__element--next")
                    .next()
                    .addClass("hero__element--extra");
                $(".hero__element--after").removeClass("hero__element--after");
                $(".hero__element--prev")
                    .prev()
                    .addClass("hero__element--after");
                break;
            case SWITCHCASES.TRANSITIONSTART:
                $(".hero__element--next")
                    .next()
                    .addClass("hero__element--extra");
                $(".hero__element--after").removeClass("hero__element--after");
                $(".hero__element--prev")
                    .prev()
                    .addClass("hero__element--after");

                break;

            default:
                break;
        }
    };

    const swiper = new Swiper($el[0], {
        modules: [A11y, Autoplay, Navigation, Pagination],
        navigation: {
            nextEl: ".hero__buttons--next",
            prevEl: ".hero__buttons--prev",
        },
        speed: 200,
        spaceBetween: 10,
        slidesPerGroupAuto: true,
        centeredSlides: false,
        slidesPerView: 3,
        allowTouchMove: false,
        slidesPerGroup: 1,
        initialSlide: 1,
        slidesPerView: "auto",
        breakpoints: {
            1024: {
                slidesPerView: 3,
                slidesPerGroup: 1,
                slidesPerGroupSkip: 2,
                centeredSlides: false,
                slidesPerGroupAuto: false,

                initialSlide: 1,
                autowidth: false,
                spaceBetween: 0,
            },
        },
        slideActiveClass: "hero__element--active",
        slideNextClass: "hero__element--next",
        slideToClickedSlide: true,
        slidePrevClass: "hero__element--prev",
        slideVisibleClass: "hero__element--visible",
        preventClicks: true,
        preventClicksPropagation: true,
        simulateTouch: false,

        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: true,
        },
        direction: handleDirection(),
        runCallbacksOnInit: false,
        autoHeight: false,

        on: {
            init: () => handleClasses(SWITCHCASES.INIT),
            slideChangeTransitionStart: (swiper) =>
                handleClasses(SWITCHCASES.TRANSITIONSTART, swiper),
            slideChangeTransitionEnd: (swiper) =>
                handleClasses(SWITCHCASES.TRANSITIONEND, swiper),
            resize: (swiper) => {
                swiper.changeDirection(handleDirection());
            },
        },
        pagination: {
            el: ".hero__pagination",
            type: "custom",
            clickable: true,
            totalClass: "hero__buttons",

            totalClass: "hero__current-element",
            renderCustom: function (swiper, current, total) {
                const displayedTotal = Math.ceil(total / 2);
                let paginationHTML = [];
                if (current > displayedTotal) {
                    const displayedCurrent = current - displayedTotal;
                    paginationHTML.push(
                        `<span class="hero__current-element">${displayedCurrent} / ${displayedTotal}</span>`
                    );
                } else {
                    paginationHTML.push(
                        `<span class="hero__current-element">${current} / ${displayedTotal}</span>`
                    );
                }

                for (let i = 1; i <= displayedTotal; i++) {
                    const isActive =
                        i === current || current - displayedTotal === i
                            ? "hero__pagination-dot hero__pagination-dot--active"
                            : "hero__pagination-dot";
                    paginationHTML.push(`<span class="${isActive}"></span>`);
                }
                return paginationHTML.join("");
            },
        },
    });
    $(".hero__buttons--pause").on("click", function (e) {
        $(".hero__buttons--pause").addClass("hero__buttons--pause-hide");
        $(".hero__buttons--play").removeClass("hero__buttons--play-hide");
        swiper.autoplay.pause();
        e.preventDefault();
    });

    $(".hero__buttons--play").on("click", function (e) {
        $(".hero__buttons--play").addClass("hero__buttons--play-hide");
        $(".hero__buttons--pause").removeClass("hero__buttons--pause-hide");

        swiper.autoplay.resume();

        e.preventDefault();
    });
};
export default heroAnimations;
